import { JSONObject } from 'module/types/common';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { HeadingCompact01 } from 'module/ui/components/styles';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import { Editor } from '@tiptap/core';
import { FC, Fragment, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AskAiRequest } from './request-renderer';
import { AskAiRequestPayload } from '../../commands/types';

const Title = styled.div`
  ${HeadingCompact01};
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-05) var(--spacing-06);
`;
const ContentWrapper = styled.div`
  overflow-y: auto;
  padding: var(--spacing-05);
  height: 100%;
`;
const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--button-ghost-border);
`;

const Wrapper = styled.div`
  width: 488px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ${Divider} {
    margin: var(--spacing-05) 0;
  }
`;

type AskAiRequest = {
  request: AskAiRequestPayload;
  parentEditor: Editor;
  renderOriginalContentWithDifference?: boolean;
};
interface Props {
  request: AskAiRequestPayload;
  editor: Editor;
  onClose: VoidFunction;
  updateContent: (content: JSONObject[]) => void;
  documentId: number;
}
export const AskAiCommandProcessor: FC<Props> = ({
  request,
  editor: parentEditor,
  onClose,
  updateContent,
  documentId,
}) => {
  // eslint-disable-next-line no-console
  console.log('request', request);
  const [requests, setRequests] = useState<AskAiRequest[]>([
    {
      request,
      parentEditor: parentEditor,
      renderOriginalContentWithDifference: false,
    },
  ]);
  const addRequest = useCallback(
    (payload: AskAiRequestPayload, editor: Editor) => {
      setRequests([
        ...requests,
        {
          request: payload,
          parentEditor: editor,
          renderOriginalContentWithDifference: true,
        },
      ]);
    },
    [requests],
  );

  return (
    <Wrapper>
      <Header>
        <Title>
          <FormattedMessage id="ask_ai_command_processor.title" />
        </Title>
        <Button
          leftIcon={<FontAwesomeIcon icon={faXmark} size={12} />}
          onClick={onClose}
        />
      </Header>
      <ContentWrapper>
        {requests.map((request, index) => (
          <Fragment key={`${request.request.command}_${index}`}>
            <AskAiRequest
              documentId={documentId}
              request={request.request}
              onAction={updateContent}
              parentEditor={request.parentEditor}
              onNewRequest={addRequest}
              renderOriginalContentWithDifference={
                request.renderOriginalContentWithDifference
              }
            />
            {index !== requests.length - 1 && <Divider />}
          </Fragment>
        ))}
      </ContentWrapper>
    </Wrapper>
  );
};
